import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { isAuthorised } from '../modules/user/selectors';
import useUniqueId from '../hooks/useUniqueId';

// a consistent overlay for simple tooltips
function Overlay({ tooltip, children }) {
  // create a unique id for this component to use for the overlay popup control
  const id = useUniqueId('private-tooltip');
  return (
    <OverlayTrigger
      placement="top"
      overlay={(
        <Tooltip id={id}>{tooltip}</Tooltip>
      )}
    >
      {children}
    </OverlayTrigger>
  );
}

// define that children are visible to only specific roles
function Private({
  children,
  isAuthorised,
  unauthorised=null,
  minUserType="User",
  className="d-inline-block",
}) {
  const { t } = useTranslation();
  if (!isAuthorised) {
    return unauthorised;
  }
  return minUserType === 'Super Admin' ? (
    <Overlay tooltip={`${t('components.private.only-visible-to')} ${minUserType}s`}>
      <div className={className}>
        {children}
      </div>
    </Overlay>
  ) : children;
}

// isAuthorised is determined by the user, organisation, and ownProps
export default connect((state, { minUserType, minOrgType }) => {
  return {
    isAuthorised: isAuthorised(state, { minUserType, minOrgType })
  };
})(Private);
